/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */

import React, { useRef, useCallback } from "react";
import Select from "react-select";

import {
  Disabled,
  FormTokenField,
  Icon,
  Button,
  Dropdown,
  RadioControl,
  Draggable,
  Panel,
  TextControl,
  TextareaControl,
  TabPanel,
  ToggleControl,
  PanelBody,
  PanelRow,
  CheckboxControl,
  SelectControl,
  ColorPicker,
  Provider,
  PopoverSlot,
  DropZone,
} from "@wordpress/components";
import {
  InspectorControls,
  useBlockProps,
  RichTextToolbarButton,
  RichText,
  AlignmentToolbar,
  BlockControls,
  SVG,
  Path,
} from "@wordpress/block-editor";
import { useState, useEffect } from "@wordpress/element";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CodeMirror from "@uiw/react-codemirror";
import { css, cssLanguage } from "@codemirror/lang-css";
import { javascript, esLint } from "@codemirror/lang-javascript";
import { basicSetup } from "codemirror";

import apiFetch from "@wordpress/api-fetch";

import { v4 as uuidv4 } from "uuid";
import Parser from "html-react-parser";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faQuestionCircle,
  faDisplay,
  faMobileScreen,
  faTabletScreenButton,
} from "@fortawesome/free-solid-svg-icons";
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";
import moment from "moment";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

export default function Edit(props) {
  const { attributes, setAttributes } = props;
  const AddRule = {
    id: uuidv4(),
    index: JSON.parse(attributes.rule_and_condition),
    data_filter: [
      {
        sub_id: uuidv4(),
        display_rule_types: "",
        values: "",
        operators: "",
        child_rule_type: 0,
      },
    ],
    rule_type: "0",
  };
  const AddRule2 = {
    id: uuidv4(),
    index: JSON.parse(attributes.rule_and_condition2),
    data_filter: [
      {
        sub_id: uuidv4(),
        display_rule_types: "",
        values: "",
        operators: "",
        child_rule_type: 0,
      },
    ],
    rule_type: "0",
  };
  const value =
    JSON.parse(attributes.rule_and_condition) === 0
      ? [AddRule]
      : JSON.parse(attributes.rule_and_condition);
  const value2 =
    JSON.parse(attributes.rule_and_condition2) === 0
      ? [AddRule2]
      : JSON.parse(attributes.rule_and_condition2);
  const [rule_and_condition, setRulesCondition] = useState(value);
  const [rule_and_condition2, setRulesCondition2] = useState(value2);
  const [product, setAddproduct] = useState([]);
  const [selectTab, setSelectTab] = useState("general-tab");
  const onSelect = (tabName) => {
    setSelectTab(tabName);
  };

  return (
    <div
      {...useBlockProps({
        className: "gb_block_main_wrapp",
      })}
    >
      <InspectorControls key="dynamic-product-block-settings">
        <React.Fragment>
          <TabPanel
            className="gb_dynamic_product_block_sett_wrapp"
            activeClass="active-tab"
            onSelect={onSelect}
            tabs={[
              {
                name: "general-tab",
                title: "General",
                className: "general-tab db-settings-tab",
              },
              {
                name: "style-tab",
                title: "Style",
                className: "style-tab db-settings-tab",
              },
              {
                name: "advanced-tab",
                title: "Advanced",
                className: "advanced-tab db-settings-tab",
              },
            ]}
          >
            {(tab) => (
              <>
                {selectTab === "general-tab" ? (
                  <GeneralComponent
                    props={props}
                    rule_and_condition={rule_and_condition}
                    rule_and_condition2={rule_and_condition2}
                    setAttributes={setAttributes}
                    setRulesCondition={setRulesCondition}
                    setRulesCondition2={setRulesCondition2}
                    product={product}
                    setAddproduct={setAddproduct}
                  ></GeneralComponent>
                ) : selectTab === "style-tab" ? (
                  <StyleComponent
                    props={props}
                    setAttributes={setAttributes}
                  ></StyleComponent>
                ) : (
                  <AdvancedComponent
                    props={props}
                    setAttributes={setAttributes}
                  ></AdvancedComponent>
                )}
              </>
            )}
          </TabPanel>
        </React.Fragment>
      </InspectorControls>
      <p>
        <ProductPreviewLoop props={props.attributes} />
      </p>
    </div>
  );
}

const ProductPreviewLoop = (props) => {
  const [product, addAddproduct] = useState([]);

  const [error, setError] = useState(null);
  const [appProducts, setPost] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [qdata, setqdata] = useState([null]);

  useEffect(() => {
    while (qdata?.length) {
      qdata.pop();
    }

    for (const [key, value] of Object.entries(props.props)) {
      let values = {
        label: key,
        value: value,
      };
      qdata.push(values);
      setqdata(qdata);
    }
    apiFetch({
      path: "/dynamicblock/v1/product-filter",
      method: "POST",
      data: props.props,
    }).then(
      (result) => {
        setIsLoaded(true);
        setPost(result);
      },
      (error) => {
        setIsLoaded(true);
        setError(error);
      }
    );
  }, [props.props]);
  // grid carosel slider changes start 28/03/2024
  const getResponsiveOptions = () => {
    switch (props.props.carousel_column) {
      case "Mobile":
        return {
          0: {
            items: props.props.mobile_slide,
            margin: props.props.mobile_spacing,
          },
          768: {
            items: props.props.tablet_slide,
            margin: props.props.tablet_spacing,
          },
          1024: {
            items: props.props.desktop_slide,
            margin: props.props.desktop_spacing,
          },
        };
      case "Tablet":
        return {
          0: {
            items: props.props.mobile_slide,
            margin: props.props.mobile_spacing,
          },
          768: {
            items: props.props.tablet_slide,
            margin: props.props.tablet_spacing,
          },
          1024: {
            items: props.props.desktop_slide,
            margin: props.props.desktop_spacing,
          },
        };
      case "Desktop":
      default:
        return {
          0: {
            items: props.props.mobile_slide,
            margin: props.props.mobile_spacing,
          },
          768: {
            items: props.props.tablet_slide,
            margin: props.props.tablet_spacing,
          },
          1024: {
            items: props.props.desktop_slide,
            margin: props.props.desktop_spacing,
          },
        };
    }
  };
  const newdata = {
    autoplay: props.props.autoplayToggle ? true : false,
    autoplayTimeout: 2000,
    stagePadding: 50,
    loop: true,
    nav: true,
    navText: [
      '<i class="dashicons dashicons-arrow-left-alt2"></i>',
      '<i class="dashicons dashicons-arrow-right-alt2"></i>',
    ],
    responsive: getResponsiveOptions(),
    // items: 2,
  };
  // grid carosel slider changes end
  if (error) {
    return <p>ERROR: {error.message}</p>;
  } else if (!isLoaded) {
    return <p>Loading..</p>;
  } else if (appProducts.length == 0) {
    return (
      <div className="db-block-preview-container">
        <div className="db-preview-main-product-wrap">
          <span>
            {__(
              "Hi, to preview the products, you must first select the logical conditions in the what to display tab. Thank you"
            )}
          </span>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className="db-block-preview-container">
          <h2>{props.props.block_title}</h2>
          {/* grid carosel slider changes class add 28/03/2024 */}
          <div
            className={`db-preview-main-product-wrap ${
              props.props.carouselToggle === false && "grid_class"
            } Desktopspacing${props.props.desktop_spacing} Tabletspacing${
              props.props.tablet_spacing
            } Mobilepacing${props.props.mobile_spacing} Desktopgrid${
              props.props.desktop_slide
            } Mobilegrid${props.props.mobile_slide} Tabletgrid${
              props.props.tablet_slide
            }`}
          >
            {props.props.carouselToggle != true ? (
              appProducts.map((obj, i) => {
                return (
                  <div className="db-preview-single-product-data" key={obj.id}>
                    <div className="db-preview-single-product-data-box">
                      <div className="db-preview-single-product-data-title">
                        <h2>{obj.post_title}</h2>
                      </div>
                      <div className="db-preview-single-product-data-image">
                        <img src={obj.feature_image} />
                      </div>
                      <div className="single-product-data-content" id={i}>
                        {props.props.excerptToggle === true ? (
                          <p>
                            {obj.post_excerpt.substring(0, 60)}
                            {obj.post_excerpt.length > 60 ? "..." : ""}
                          </p>
                        ) : (
                          ""
                        )}
                        <span class="db-preview-price-wrap">
                          {Parser(JSON.parse(obj.price_html))}
                        </span>
                        {props.props.addToCartBtnToggle === true ? (
                          <a
                            href="#"
                            class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
                          >
                            Add to Cart
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <OwlCarousel className="owl-theme" {...newdata}>
                {appProducts?.map((obj, i) => {
                  if (i + 1 <= props?.props?.limit) {
                    return (
                      <div
                        className="db-preview-single-product-data"
                        key={obj.id}
                      >
                        <div className="db-preview-single-product-data-box">
                          <div className="db-preview-single-product-data-title">
                            <h2>{obj.post_title}</h2>
                          </div>
                          <div className="db-preview-single-product-data-image">
                            <img src={obj.feature_image} />
                          </div>
                          <div className="single-product-data-content" id={i}>
                            {props.props.excerptToggle === true ? (
                              <p>
                                {obj.post_excerpt.substring(0, 60)}
                                {obj.post_excerpt.length > 60 ? "..." : ""}
                              </p>
                            ) : (
                              ""
                            )}
                            <span class="db-preview-price-wrap">
                              {Parser(JSON.parse(obj.price_html))}
                            </span>
                            {props.props.addToCartBtnToggle === true ? (
                              <a
                                href="#"
                                class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
                              >
                                Add to objectCart
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  } else if (props?.props?.limit?.length === 0) {
                    return (
                      <div
                        className="db-preview-single-product-data"
                        key={obj.id}
                      >
                        <div className="db-preview-single-product-data-box">
                          <div className="db-preview-single-product-data-title">
                            <h2>{obj.post_title}</h2>
                          </div>
                          <div className="db-preview-single-product-data-image">
                            <img src={obj.feature_image} />
                          </div>
                          <div className="single-product-data-content" id={i}>
                            {props.props.excerptToggle === true ? (
                              <p>
                                {obj.post_excerpt.substring(0, 60)}
                                {obj.post_excerpt.length > 60 ? "..." : ""}
                              </p>
                            ) : (
                              ""
                            )}
                            <span class="db-preview-price-wrap">
                              {Parser(JSON.parse(obj.price_html))}
                            </span>
                            {props.props.addToCartBtnToggle === true ? (
                              <a
                                href="#"
                                class="button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart"
                              >
                                Add to Cart
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </OwlCarousel>
            )}
          </div>
        </div>
      </>
    );
  }
};

const GeneralComponent = (props) => {
  const { attributes, setAttributes } = props;
  const getAttr = props.props.attributes;

  console.log("getAttr", getAttr);

  const [titleStatus, setStatustitle] = useState(getAttr.show_block_title);

  const rule_and_condition = props?.rule_and_condition;
  const setRulesCondition = props?.setRulesCondition;
  const [dragstatus, setDragstatus] = useState(false);
  const [statusdrag, setStatusdrag] = useState(false);
  const [RulesTypes] = useState([]);
  const [removeform, setRemoveform] = useState(false);
  const [defaultreset, setdefaultreset] = useState(false);
  const [options] = useState([]);
  const dragItem = useRef();
  const dragOverItem = useRef();

  const rule_and_condition2 = props?.rule_and_condition2;
  const setRulesCondition2 = props?.setRulesCondition2;
  const [dragstatus2, setDragstatus2] = useState(false);
  const [statusdrag2, setStatusdrag2] = useState(false);
  const [RulesTypes2] = useState([]);
  const [removeform2, setRemoveform2] = useState(false);
  const [defaultreset2, setdefaultreset2] = useState(false);
  const [options2] = useState([]);
  const dragItem2 = useRef();
  const dragOverItem2 = useRef();

  useEffect(() => {
    getAlldata();
  }, []);

  // what to display dataset remove cross sign
  useEffect(() => {
    removeCrosssign();
  }, [props?.props?.attributes?.dataset]);

  const removeCrosssign = () => {
    const isClearables = document.getElementById("db_panel_dataset");
    const child = document.getElementsByClassName(
      "css-12a83d4-MultiValueRemove"
    );
    const remove = child[0]?.setAttribute("id", "css-12a83d4-MultiValueRemove");
    if (
      props?.props?.attributes?.dataset?.length === 1 &&
      isClearables &&
      child
    ) {
      const Removecross = document.getElementById(
        "css-12a83d4-MultiValueRemove"
      );
      if (Removecross) {
        document.getElementById("css-12a83d4-MultiValueRemove").style.display =
          "none";
      }
    } else {
      if (child[0] !== undefined) {
        document.getElementById("css-12a83d4-MultiValueRemove").style.display =
          "";
      }
    }
  };

  // what to display dataset2 remove cross sign
  useEffect(() => {
    removeCrosssign2();
  }, [props?.props?.attributes?.dataset2]);

  const removeCrosssign2 = () => {
    const isClearables2 = document.getElementById("db_panel_dataset2");
    const child2 = document.getElementsByClassName(
      "css-12a83d4-MultiValueRemove"
    );
    const remove = child2[0]?.setAttribute(
      "id",
      "css-12a83d4-MultiValueRemove2"
    );
    if (
      props?.props?.attributes?.dataset2?.length === 1 &&
      isClearables2 &&
      child2
    ) {
      const Removecross = document.getElementById(
        "css-12a83d4-MultiValueRemove2"
      );
      if (Removecross) {
        document.getElementById("css-12a83d4-MultiValueRemove2").style.display =
          "none";
      }
    } else {
      if (child2[0] !== undefined) {
        document.getElementById("css-12a83d4-MultiValueRemove2").style.display =
          "";
      }
    }
  };

  // const dragelement = (e, position, status, module_number) => {
  // 	if (module_number === 0) {
  // 		setStatusdrag(status);
  // 		return dragStart(e, position, module_number);
  // 	} else {
  // 		setStatusdrag2(status);
  // 		return dragStart(e, position, module_number);
  // 	}
  // };

  const dragelement = useCallback((e, position, module_number) => {
    if (module_number === 0) {
      setStatusdrag(true);
      dragStart(e, position, module_number);
      document.addEventListener(
        "mouseup",
        () => {
          setStatusdrag(false);
        },
        { once: true }
      );
    } else {
      setStatusdrag2(true);
      dragStart(e, position, module_number);
      document.addEventListener(
        "mouseup",
        () => {
          setStatusdrag2(false);
        },
        { once: true }
      );
    }
    document.addEventListener("mouseup", () => {}, { once: true });
  }, []);

  const dragStart = (e, position, module_number) => {
    if (module_number === 0) {
      return (dragItem.current = position);
    } else {
      return (dragItem2.current = position);
    }
  };

  const dragOver = (module_number) => {
    if (module_number === 0 && statusdrag === true) {
      // return setStatusdrag(false);
    } else if (statusdrag2 === true) {
      return setStatusdrag2(false);
    }
  };

  const dragEnter = (e, position, module_number) => {
    if (module_number === 0) {
      return (dragOverItem.current = position);
    } else {
      return (dragOverItem2.current = position);
    }
  };
  const drop = (e) => {
    // when to display
    const copyListItems2 = [...rule_and_condition2];
    const dragItemContent2 = copyListItems2[dragItem2.current];
    copyListItems2.splice(dragItem2.current, 1);
    copyListItems2.splice(dragOverItem2.current, 0, dragItemContent2);
    dragItem2.current = null;
    dragOverItem2.current = null;
    let newlist = copyListItems2?.map((list, index) => {
      list.index = index;
      return list;
    });
    setRulesCondition2(newlist);
    if (newlist?.length) {
      setStatusdrag2(false);
      setDragstatus2(true);
      return props.setAttributes({
        rule_and_condition2: JSON.stringify(newlist),
      });
    }
  };

  const drop1 = (e) => {
    // what to display
    const copyListItems = [...rule_and_condition];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    let newlist = copyListItems?.map((list, index) => {
      list.index = index;
      return list;
    });
    setRulesCondition(newlist);
    if (newlist?.length) {
      setStatusdrag(false);
      setDragstatus(true);
      return props.setAttributes({
        rule_and_condition: JSON.stringify(newlist),
      });
    }
  };
  const getAlldata = () => {
    // What to display
    apiFetch({ path: "/dynamicblock/v1/all_display_rule_types" }).then(
      (posts) => {
        for (const [key, value] of Object.entries(posts)) {
          let rules = {
            label: key,
            value: key,
          };
          options.push(rules);
          const status = getAttr?.dataset?.length === 0 ? true : false;
          const status1 = getAttr?.dataset === undefined ? true : false;
          if (options?.length && (status || status1)) {
            setAttributes({ dataset: options });
          }

          for (const [key, value] of Object.entries(posts[rules?.value])) {
            let values = {
              label: value[key],
              value: key,
              optionType: rules.value,
              disabled: key === "pro_version" ? true : false,
              alloption: value?.rule_types,
            };
            RulesTypes.push(values);
          }
        }
      }
    );

    // When to display
    apiFetch({ path: "/dynamicblock/v1/all_when_to_display_rule" }).then(
      (posts) => {
        for (const [key, value] of Object.entries(posts)) {
          let rules = {
            label: key,
            value: key,
          };
          options2.push(rules);

          const status = getAttr?.dataset2?.length === 0 ? true : false;
          const status1 = getAttr?.dataset2 === undefined ? true : false;
          if (options2?.length && (status || status1)) {
            setAttributes({ dataset2: options2 });
          }
          for (const [key, value] of Object.entries(posts[rules?.value])) {
            let values = {
              label: value[key],
              value: key,
              optionType: rules.value,
              disabled: key === "pro_version" ? true : false,
              alloption: value?.rule_types,
            };
            RulesTypes2.push(values);
          }
        }
      }
    );
  };

  const AddedProduct = (module_number) => {
    if (module_number === 0) {
      const AddRules = {
        id: uuidv4(),
        index: rule_and_condition?.length,
        data_filter: [
          {
            sub_id: uuidv4(),
            display_rule_types: "",
            values: "",
            operators: "",
            child_rule_type: 0,
          },
        ],
        rule_type: "0",
      };
      rule_and_condition.push(AddRules);
      setRulesCondition(rule_and_condition);
      if (rule_and_condition.length) {
        props.setAttributes({
          rule_and_condition: JSON.stringify(rule_and_condition),
        });
      }
    } else {
      const AddRules2 = {
        id: uuidv4(),
        index: rule_and_condition2?.length,
        data_filter: [
          {
            sub_id: uuidv4(),
            display_rule_types: "",
            values: "",
            operators: "",
            child_rule_type: 0,
          },
        ],
        rule_type: "0",
      };
      rule_and_condition2.push(AddRules2);
      setRulesCondition2(rule_and_condition2);
      if (rule_and_condition2.length) {
        props.setAttributes({
          rule_and_condition2: JSON.stringify(rule_and_condition2),
        });
      }
    }
  };

  const removeProduct = (list, module_number) => {
    if (module_number === 0) {
      const removedata = rule_and_condition?.filter(
        (listid) => listid.id !== list.id
      );
      setRulesCondition(removedata);
      setRemoveform(true);
      props.setAttributes({ rule_and_condition: JSON.stringify(removedata) });
    } else {
      const removedata2 = rule_and_condition2?.filter(
        (listid) => listid.id !== list.id
      );
      setRulesCondition2(removedata2);
      setRemoveform2(true);
      props.setAttributes({ rule_and_condition2: JSON.stringify(removedata2) });
    }
  };

  const setoptions = (status, list, module_number) => {
    if (module_number === 0) {
      const setoptiondata = rule_and_condition.map((listid) => {
        if (listid.id === list.id) {
          listid.rule_type = status;
          return listid;
        } else {
          return listid;
        }
      });
      setRulesCondition(setoptiondata);
      props.setAttributes({
        rule_and_condition: JSON.stringify(rule_and_condition),
      });
    } else {
      const setoptiondata = rule_and_condition2.map((listid) => {
        if (listid.id === list.id) {
          listid.rule_type = status;
          return listid;
        } else {
          return listid;
        }
      });
      setRulesCondition2(setoptiondata);
      props.setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
    }
  };

  const toggleTitle = () => {
    setStatustitle((titleStatus) => !titleStatus);
    setAttributes({ show_block_title: !titleStatus });
  };
  // end 01-MAR-2024
  // for tooltip
  const renderContent = (condition) => {
    if (condition === "Rules & Conditions") {
      return (
        <>
          <h5 className="tooltip_title">
            {__("Rules & condition")}
            <span class="tooltip">
              <FontAwesomeIcon
                icon={faQuestionCircle}
                style={{ paddingLeft: "3px" }}
              />
              <span class="tooltip-content">
                <img
                  src="../wp-content/plugins/dynamicblocks/assets/images/logo_dynamicblock.svg"
                  alt="Tooltip Image"
                />
                <span>
                  {__("Utilize dynamic rules and conditions to refine your product suggestions.")}
                </span>
              </span>
            </span>
          </h5>
        </>
      );
    } else if (condition === "Datasets") {
      return (
        <>
          <h5 className="tooltip_title">
            {__("Datasets")}
            <span class="tooltip">
              <FontAwesomeIcon
                icon={faQuestionCircle}
                style={{ paddingLeft: "3px" }}
              />
              <span class="tooltip-content">
                <img
                  src="../wp-content/plugins/dynamicblocks/assets/images/logo_dynamicblock.svg"
                  alt="Tooltip Image"
                />
                <span>{__("Datasets are groups of conditions that allow you to filter products based on specific criteria.")}.</span>
              </span>
            </span>
          </h5>
        </>
      );
    }
  };

  // end tooltip
  return (
    <>
      <PanelBody
        className="bg_general_tab_content bg_block_tab_content_wrap"
        title="Block Info"
        initialOpen={true}
      >
        <PanelRow>
          <div className="block-info-container">
            <p>{__("Choose a Block Title or leave blank.")}</p>
          </div>
        </PanelRow>

        <PanelRow>
          <TextControl
            label={__("Title")}
            placeholder={__("example name")}
            help={__("insert block title")}
            value={getAttr.block_title}
            onChange={(val) => {
              setAttributes({ block_title: val });
            }}
          />

          <div style={{ position: "relative" }}>
            <ToggleControl
              className="gb-toggle-control"
              label={__("Show Block Title")}
              help={__("show/hide block title")}
              checked={titleStatus}
              onChange={() => toggleTitle()}
            />
          </div>
        </PanelRow>

        <PanelRow>
          <div>
            <TextareaControl
              label={__("Note")}
              type="textarea"
              placeholder={__("example desc")}
              value={getAttr.block_note}
              onChange={(val) => setAttributes({ block_note: val })}
              help={__(
                "write some notes on the block to remember what it is for"
              )}
            />
          </div>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("What to display")} initialOpen={false}>
        <PanelRow>
          <div class="db_panel_whtd_note">
            <p className="">
              {__(
                "Choose the products you would like to show based on customizable criteria. Note: If you are using the html block type within the editor you can also invoke wordpress shortcodes."
              )}
            </p>
          </div>
        </PanelRow>
        <PanelRow>
          <div class="db_panel_dataset_and_ordering">
            <div id="db_panel_dataset" class="db_panel_dataset">
              {renderContent("Datasets")}

              <Select
                value={getAttr?.dataset}
                options={options}
                isMulti={true}
                // closeMenuOnSelect={true}
                onChange={(tokens) => {
                  if (tokens.length > 0) {
                    setdefaultreset(true);
                    setAttributes({ dataset: tokens });
                  }
                }}
              />
            </div>
            <div class="db_panel_dataset_order_limit">
              <SelectControl
                label="Order By"
                value={getAttr.order_by}
                options={[
                  { label: "Date", value: "date" },
                  { label: "Name", value: "title" },
                  { label: "Random", value: "rand" },
                ]}
                onChange={(opt) => setAttributes({ order_by: opt })}
              />
              <SelectControl
                label="Mode"
                value={getAttr.mode}
                options={[
                  { label: "ASC", value: "acs" },
                  { label: "DESC", value: "desc" },
                ]}
                onChange={(tokens) => setAttributes({ mode: tokens })}
              />
              <TextControl
                label={__("Limit")}
                placeholder={__("5")}
                value={getAttr.limit}
                onChange={(value) => {
                  const val = value.replace(/\D/g, "");
                  // setAttributes({ limit: '0' }
                  if (val > 0) {
                    return setAttributes({ limit: val });
                  } else {
                    return setAttributes({ limit: "" });
                  }
                }}
              />
            </div>
          </div>
        </PanelRow>
        <PanelRow>
          <div>
            <div class="db_panel_rc">
              {renderContent("Rules & Conditions")}
              <p className="">
                {__(
                  "Create your own set of rules to choose which products to show."
                )}
              </p>
            </div>
            {rule_and_condition?.length && rule_and_condition?.length >= 1
              ? rule_and_condition?.map((list, index) => {
                  return (
                    <>
                      <div
                        className={
                          statusdrag === true
                            ? "gb-product-rules-wrap draggable_active"
                            : "gb-product-rules-wrap"
                        }
                        onDragStart={(e) => dragStart(e, index, 0)}
                        onDragEnter={(e) => dragEnter(e, index, 0)}
                        onDragEnd={drop1}
                        key={index}
                        draggable={statusdrag}
                      >
                        <div className="bg_panel_single_rule">
                          <RadioControl
                            draggable={false}
                            selected={list?.rule_type}
                            className="radio-option111"
                            options={[
                              { label: "AND", value: "0" },
                              { label: "OR", value: "1" },
                            ]}
                            onChange={(value) => setoptions(value, list, 0)}
                          />
                          <div class="bg_panel_btns_wrapp">
                            <button
                              onMouseDown={(e) => dragelement(e, index, 0)}
                              onMouseUp={(e) => dragelement(e, index, false, 0)}
                              onMouseLeave={(e) => {
                                dragOver(0);
                              }}
                              class="db_panel_btn_drag"
                            >
                              <span class="dashicons dashicons-editor-expand"></span>
                            </button>
                            <button
                              class="db_panel_btn_add"
                              onClick={() => AddedProduct(0)}
                            >
                              <span class="dashicons dashicons-plus"></span>
                            </button>
                            {rule_and_condition &&
                            rule_and_condition.length > 1 ? (
                              <button
                                class="db_panel_btn_remove"
                                onClick={() => removeProduct(list, 0)}
                              >
                                <span class="dashicons dashicons-minus"></span>
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="menu-block">
                          {list?.data_filter?.map((subdata, i) => {
                            return (
                              <ProductSubCategory
                                setAttributes={setAttributes}
                                rule_and_condition={rule_and_condition}
                                list={list}
                                subdata={subdata}
                                RulesTypes={RulesTypes}
                                setRulesCondition={setRulesCondition}
                                removeform={removeform}
                                defaultreset={defaultreset}
                                setdefaultreset={setdefaultreset}
                                setRemoveform={setRemoveform}
                                attributes={props.props?.attributes}
                                dragstatus={dragstatus}
                                setDragstatus={setDragstatus}
                                removeCrosssign={removeCrosssign}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </>
                  );
                })
              : ""}
          </div>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("When to display")} initialOpen={false}>
        <PanelRow>
          <div class="db_panel_whtd_note">
            <p className="">
              {__(
                "When should the block be displayed ? Create your own dynamic rules."
              )}
            </p>
          </div>
        </PanelRow>
        <PanelRow>
          <div class="db_panel_dataset_and_ordering">
            <div id="db_panel_dataset2" class="db_panel_dataset">
              <label>{__("Datasets")}</label>
              <div class="db_panel_whtd_note">
                {/* <p className="">
									{__(
										"Datasets are groups of conditions that you can use to apply your own conditions to block. Click to select your datasets	"
									)}
								</p> */}
              </div>
              <Select
                value={getAttr?.dataset2}
                options={options2}
                isMulti={true}
                onChange={(tokens) => {
                  if (tokens.length > 0) {
                    // setdefaultreset2(true);
                    setAttributes({ dataset2: tokens });
                  }
                }}
              />
            </div>
          </div>
        </PanelRow>
        <PanelRow>
          <div>
            <div class="db_panel_rc">
              <h3>{__("Rules & Conditions")}</h3>
              <p className="">
                {__(
                  "Create your own set of rules to choose which products to show."
                )}
              </p>
            </div>
            {rule_and_condition2?.length && rule_and_condition2?.length >= 1
              ? rule_and_condition2?.map((list, index) => {
                  return (
                    <>
                      <div
                        className={
                          statusdrag2 === true
                            ? "gb-product-rules-wrap draggable_active"
                            : "gb-product-rules-wrap"
                        }
                        onDragStart={(e) => dragStart(e, index, 1)}
                        onDragEnter={(e) => dragEnter(e, index, 1)}
                        onDragEnd={drop}
                        key={index}
                        draggable={statusdrag2}
                      >
                        <div className="bg_panel_single_rule">
                          <RadioControl
                            draggable={false}
                            selected={list?.rule_type}
                            className="radio-option111"
                            options={[
                              { label: "AND", value: "0" },
                              { label: "OR", value: "1" },
                            ]}
                            onChange={(value) => setoptions(value, list, 1)}
                          />
                          <div class="bg_panel_btns_wrapp">
                            <button
                              onMouseDown={(e) => dragelement(e, index, 1)}
                              onMouseUp={(e) => dragelement(e, index, false, 1)}
                              onMouseLeave={(e) => {
                                dragOver(1);
                              }}
                              class="db_panel_btn_drag"
                            >
                              <span class="dashicons dashicons-editor-expand"></span>
                            </button>
                            <button
                              class="db_panel_btn_add"
                              onClick={() => AddedProduct(1)}
                            >
                              <span class="dashicons dashicons-plus"></span>
                            </button>
                            {rule_and_condition2 &&
                            rule_and_condition2.length > 1 ? (
                              <button
                                class="db_panel_btn_remove"
                                onClick={() => removeProduct(list, 1)}
                              >
                                <span class="dashicons dashicons-minus"></span>
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="menu-block">
                          {list?.data_filter?.map((subdata, i) => {
                            return (
                              <ProductSubCategory2
                                setAttributes={setAttributes}
                                rule_and_condition2={rule_and_condition2}
                                list={list}
                                subdata={subdata}
                                RulesTypes2={RulesTypes2}
                                setRulesCondition2={setRulesCondition2}
                                removeform2={removeform2}
                                defaultreset2={defaultreset2}
                                setdefaultreset2={setdefaultreset2}
                                setRemoveform2={setRemoveform2}
                                attributes={props.props?.attributes}
                                dragstatus2={dragstatus2}
                                setDragstatus2={setDragstatus2}
                                removeCrosssign2={removeCrosssign2}
                              />
                            );
                          })}
                        </div>
                      </div>
                    </>
                  );
                })
              : ""}
          </div>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("Where to Display")} initialOpen={false}>
        <PanelRow>
          <Disabled isDisabled>
            <TextControl label={__("Page")} placeholder={__("Custom Page")} />
            <TextControl
              label={__("Location")}
              placeholder={__("Current Page")}
            />
          </Disabled>
        </PanelRow>
      </PanelBody>
    </>
  );
};

const ProductSubCategory2 = (props) => {
  const {
    rule_and_condition2,
    setAttributes,
    attributes,
    setRulesCondition2,
    list,
    RulesTypes2,
    removeform2,
    setRemoveform2,
    dragstatus2,
    defaultreset2,
    setdefaultreset2,
    setDragstatus2,
    removeCrosssign2,
    subdata,
  } = props;
  const [ProductOption, setProductOption] = useState([]);
  const [option, setoption] = useState();
  const [inputstatus, setinputstatus] = useState(Boolean);
  const [opreatorOption, setopreatorOption] = useState([]);
  const [condition_input_type, setCondition_input_type] = useState(true);
  const [inputType, setInputType] = useState("text");

  useEffect(() => {
    if (removeform2 || dragstatus2) {
      selectrules(subdata?.display_rule_types, false);
    }
  }, [rule_and_condition2]);

  useEffect(() => {
    if (subdata?.display_rule_types?.length > 0) {
      selectrules(subdata?.display_rule_types, false);
    } else {
      let defaultOption = RulesTypes2?.filter((option) => {
        return option?.optionType === attributes?.dataset2[0].value;
      });
      selectrules(defaultOption[0]?.value, false);
    }
    removeCrosssign2();
  }, [list?.data_filter.length]);

  useEffect(() => {
    if (subdata?.display_rule_types) {
      const optionTypess = RulesTypes2?.find((getopt) => {
        return getopt?.value === subdata?.display_rule_types;
      });
      if (optionTypess) {
        let resetOption = attributes?.dataset2?.filter((option) => {
          return option?.value === optionTypess?.optionType;
        });
        if (resetOption.length === 0) {
          subdata.values = "";
          subdata.operators = "";
          let defaultOption = RulesTypes2?.filter((option) => {
            return option?.optionType === attributes?.dataset[0]?.value;
          });
          if (defaultOption) {
            return selectrules(defaultOption[0]?.value, false);
          }
        }
      }
    }
  }, [attributes?.dataset2]);

  const getListCondition = async (display, status) => {
    await resetData(status);
    const pro_version = RulesTypes2?.filter((pro) => {
      return pro.value === display;
    });
    if (pro_version.length > 0) {
      getDetails(pro_version[0]?.value, status, "version");
    } else {
      getDetails(RulesTypes2[0]?.value, status, "pro_version");
    }
  };
  const getDetails = (display, status, versions) => {
    subdata.display_rule_types = display;
    const postss = RulesTypes2?.filter((data) => {
      if (data?.value === display) {
        return data;
      }
    });

    if (postss[0]?.alloption) {
      if (postss[0]?.alloption?.condition_input_type) {
        if (
          postss[0]?.alloption?.condition_input_type === "Product_Select" ||
          postss[0]?.alloption?.condition_input_type === "Chosen_Select"
        ) {
          setinputstatus(false);
          setCondition_input_type(true);
        } else if (postss[0]?.alloption?.condition_input_type === "select") {
          setinputstatus(false);
          setCondition_input_type(false);
        } else if (
          postss[0]?.alloption?.condition_input_type === "Price_Select" ||
          postss[0]?.alloption?.condition_input_type === "Text" ||
          postss[0]?.alloption?.condition_input_type === "Store_Order_Count"
        ) {
          setInputType("text");
          setinputstatus(true);
        } else if (
          postss[0]?.alloption?.condition_input_type === "Order_Status" ||
          postss[0]?.alloption?.condition_input_type === "Select"
        ) {
          setinputstatus(false);
          setCondition_input_type(true);
        } else if (
          postss[0]?.alloption?.condition_input_type === "schedule_date_time"
        ) {
          setInputType("date");
          setinputstatus(true);
          setCondition_input_type(true);
        } else if (postss[0]?.alloption?.condition_input_type === "Number") {
          setInputType("number");
          setinputstatus(true);
          setCondition_input_type(true);
        } else if (
          postss[0]?.alloption?.condition_input_type === "Html_Always"
        ) {
          setInputType("text");
          setinputstatus(true);
        } else if (
          postss[0]?.alloption?.condition_input_type === "text_area_default"
        ) {
          setInputType("text");
          setinputstatus(true);
        }
      }
      if (
        opreatorOption.length === 0 &&
        postss[0]?.alloption?.operators !== null
      ) {
        let operator = postss[0]?.alloption?.operators;
        for (const [key, value] of Object?.entries(operator)) {
          let rules = {};
          (rules.label = value),
            (rules.value = key),
            opreatorOption.push(rules);
          setopreatorOption(opreatorOption);
        }
      }
      //  values
      if (ProductOption.length === 0) {
        let values = postss[0]?.alloption?.values;
        if (postss[0]?.alloption?.condition_input_type === "Html_Always") {
          let rules = {};
          (rules.label = "Html_Always"),
            (rules.value = values),
            ProductOption.push(rules);
          setProductOption(ProductOption);
          subdata.values = JSON.stringify([ProductOption[0]]);
          setRulesCondition2(rule_and_condition2);
          setAttributes({
            rule_and_condition2: JSON.stringify(rule_and_condition2),
          });
        } else {
          for (const [key, value] of Object?.entries(values)) {
            let rules = {};

            (rules.label = value),
              (rules.value = key),
              ProductOption.push(rules);
            setProductOption(ProductOption);
          }
        }
      }
      return applyconditions(status, versions);
    }
  };
  const AddedSubProduct = () => {
    setweekday(false);
    const newSubRules = {
      sub_id: uuidv4(),
      display_rule_types: "",
      values: "",
      operators: "",
      child_rule_type: 0,
    };
    list?.data_filter?.push(newSubRules);
    setRulesCondition2(rule_and_condition2);
    setAttributes({
      rule_and_condition2: JSON.stringify(rule_and_condition2),
    });
  };

  const removeSubProduct = (subdata_id) => {
    setweekday(false);
    const removeval = list?.data_filter?.filter((sub) => {
      if (sub?.sub_id !== subdata_id) {
        return sub;
      }
    });
    if (removeval[0]?.sub_id?.length > 0) {
      while (list?.data_filter?.length) {
        list?.data_filter.pop();
      }
      if (removeval[0]?.sub_id?.length > 0 && list?.data_filter.length === 0) {
        removeval.map((data_remain) => {
          list?.data_filter.push(data_remain);
          setRulesCondition2(rule_and_condition2);
          return setAttributes({
            rule_and_condition2: JSON.stringify(rule_and_condition2),
          });
        });
      }
    }
  };
  const applyconditions = (status, versions) => {
    if (defaultreset2) {
      setOperator(opreatorOption[0]?.value);
      subdata.values = "";
      setoption([]);
      setdefaultreset2(false);
      setRulesCondition2(rule_and_condition2);
      return setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
    } else if (
      !defaultreset2 &&
      !dragstatus2 &&
      removeform2 &&
      subdata.values?.length &&
      subdata.operators?.length
    ) {
      // when defaultreset2  is false and removeform2
      const selectremoveform =
        subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
      setoption(selectremoveform);
      setRemoveform2(false);
    } else if (dragstatus2) {
      setoption([]);
      setDragstatus2(false);
      const val =
        subdata?.values.length === 0 ? "" : JSON.parse(subdata?.values);
      return setoption(val);
    } else if (status) {
      if (ProductOption[0]?.label === "Html_Always") {
        subdata.values = JSON.stringify(ProductOption);
        setRulesCondition2(rule_and_condition2);
        setAttributes({
          rule_and_condition2: JSON.stringify(rule_and_condition2),
        });
      }
      subdata.values = "";
      subdata.operators = opreatorOption[0]?.value;
      setOperator(opreatorOption[0]?.value);
    } else if (versions === "pro_version") {
      subdata.operators = "";
      subdata.values = "";
      setoption([]);
      setRulesCondition2(rule_and_condition2);
      return setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
    } else {
      const selectedoption =
        subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
      setoption(selectedoption);
    }
  };

  const resetData = async (status) => {
    if (status) {
      setoption([]);
    }
    while (opreatorOption?.length) {
      opreatorOption.pop();
    }

    while (ProductOption?.length) {
      ProductOption.pop();
    }
    setopreatorOption([]);
    setRulesCondition2(rule_and_condition2);
    setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
  };

  const selectrules = (option, status) => {
    setSelectedDays([]);
    setDaterange({
      start: null,
      end: null,
      startDate: null,
      endDate: null,
    });
    // setIsValid(true);
    setInputType("");
    setoption([]);
    setinput("");
    subdata.display_rule_types = option;
    getListCondition(option, status);
    setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
  };

  const setOperator = (option) => {
    subdata.operators = option;
    setRulesCondition2(rule_and_condition2);
    setAttributes({ rule_and_condition2: JSON.stringify(rule_and_condition2) });
  };

  const setproducts = (option, type) => {
    subdata.operators = subdata.operators?.length > 0 ? subdata.operators : "";
    if ("option" === type) {
      if (condition_input_type) {
        subdata.values = JSON.stringify(option);
      } else {
        subdata.values = JSON.stringify([option]);
      }
      setoption(option);
      setRulesCondition2(rule_and_condition2);
      setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
    } else if (type === "date") {
      setdefaultday(true);
      setSelectedDays((prevCheckedItems) => {
        const isItemChecked = prevCheckedItems?.some(
          (item) => item?.id === option?.id
        );
        // Toggle the selection state
        const updatedItems = isItemChecked
          ? prevCheckedItems?.filter((item) => item?.id !== option?.id)
          : [...prevCheckedItems, { id: option?.id, day: option?.day }];
        return updatedItems;
      });
    } else if (inputstatus) {
      const { type, value } = option.target;
      let objectval = {
        label: type,
        value: value,
      };
      subdata.values = JSON.stringify([objectval]);
      setoption(objectval);
      setRulesCondition2(rule_and_condition2);
      setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
    }
  };
  const daysOfWeek = [
    { id: 1, day: "S" },
    { id: 2, day: "M" },
    { id: 3, day: "T" },
    { id: 4, day: "W" },
    { id: 5, day: "T" },
    { id: 6, day: "F" },
    { id: 7, day: "S" },
  ];
  const [defaultday, setdefaultday] = useState(false);
  const [defaultday2, setdefaultday2] = useState(false);
  const [weekday, setweekday] = useState(true);
  const [daterange, setDaterange] = useState({
    start: null,
    end: null,
    startDate: null,
    endDate: null,
  });
  const [selectedDays, setSelectedDays] = useState([]);
  useEffect(() => {
    if (!dragstatus2 && subdata.values?.length) {
      setweekday(false);
      const savedvalue =
        subdata?.display_rule_types === "schedule"
          ? JSON.parse(subdata?.values)
          : "";
      const urldatavalue =
        subdata?.display_rule_types === "url_path" ||
        subdata?.display_rule_types === "query_string"
          ? JSON.parse(subdata?.values)
          : "";
      setinput(urldatavalue?.sourceUrl);
      const defaultDateRange = savedvalue?.daterange;
      if (defaultDateRange) {
        let dateRange = {
          start:
            defaultDateRange.start != null
              ? new Date(defaultDateRange.start)
              : null,
          startDate:
            defaultDateRange.startDate != null
              ? defaultDateRange.startDate
              : null,
          end:
            defaultDateRange.end != null
              ? new Date(defaultDateRange.end)
              : null,
          endDate:
            defaultDateRange.endDate != null ? defaultDateRange.endDate : null,
        };
        // const [option, setoption] = useState();
        // const [inputstatus,setinputstatus] = useState(Boolean);
        // const [opreatorOption, setopreatorOption] = useState([]);
        setDaterange(dateRange);
        const defaultWeek =
          savedvalue?.daysOfWeekdata?.length > 0
            ? savedvalue?.daysOfWeekdata
            : [];
        setSelectedDays(defaultWeek);
      }
      setRemoveform2(false);
    } else if (dragstatus2) {
      setDragstatus2(false);
      setDaterange({});
      setSelectedDays([]);
      const savedvalue =
        subdata?.values.length === 0 ? "" : JSON.parse(subdata?.values);
      const defaultDateRange = savedvalue.daterange;
      let dateRange = {
        start:
          defaultDateRange?.start != null
            ? new Date(defaultDateRange?.start)
            : null,
        startDate:
          defaultDateRange?.startDate != null
            ? defaultDateRange?.startDate
            : null,
        end:
          defaultDateRange?.end != null ? new Date(defaultDateRange.end) : null,
        endDate:
          defaultDateRange?.endDate != null ? defaultDateRange?.endDate : null,
      };
      setDaterange(dateRange);
      const defaultWeek =
        savedvalue?.daysOfWeekdata?.length > 0
          ? savedvalue?.daysOfWeekdata
          : [];
      setSelectedDays(defaultWeek);
    }
  }, [removeform2, dragstatus2]);
  // const [isValid, setIsValid] = useState(true);
  const handleStartDateChange = (date) => {
    let newDate = moment(date).format("YYYY-MM-DD HH:mm");
    setDaterange((prevRange) => ({
      ...prevRange,
      start: date,
      startDate: newDate,
    }));
    // const isValidDateTime = validateDateTime(daterange.startDate)
    // setIsValid(isValidDateTime);
    // setDaterange((prevRange) => ({ ...prevRange, startDate: newDate }));
    setdefaultday(true);
  };
  const handleEndDateChange = (date) => {
    let newDate = moment(date).format("YYYY-MM-DD HH:mm");
    setDaterange((prevRange) => ({
      ...prevRange,
      end: date,
      endDate: newDate,
    }));
    // setDaterange((prevRange) => ({ ...prevRange, endDate: newDate }));
    setdefaultday(true);
  };
  useEffect(() => {
    setweekday(false);
    if (defaultday) {
      const date = {
        daysOfWeekdata: selectedDays,
        daterange: daterange,
      };
      subdata.values = JSON.stringify(date);
      subdata.operators = inputType === "date" && "==";
      setRulesCondition2(rule_and_condition2);
      setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
      setdefaultday(false);
    } else if (weekday === false && subdata?.values) {
      const savedvalue =
        subdata?.display_rule_types === "schedule"
          ? JSON?.parse(subdata?.values)
          : "";
      0;
      setSelectedDays(savedvalue?.daysOfWeekdata);
      const defaultDateRange = savedvalue.daterange;
      let dateRange = {
        start:
          defaultDateRange?.start != null
            ? new Date(defaultDateRange?.start)
            : null,
        startDate:
          defaultDateRange?.startDate != null
            ? defaultDateRange?.startDate
            : null,
        end:
          defaultDateRange?.end != null
            ? new Date(defaultDateRange?.end)
            : null,
        endDate:
          defaultDateRange?.endDate != null ? defaultDateRange?.endDate : null,
      };
      setDaterange(dateRange);
    }
    0;
  }, [weekday, defaultday, selectedDays, daterange]);
  const [input, setinput] = useState("");
  useEffect(() => {
    setweekday(true);
    if (defaultday2) {
      const urldata = {
        value: input,
      };
      subdata.values = JSON.stringify([urldata]);
      setRulesCondition2(rule_and_condition2);
      setAttributes({
        rule_and_condition2: JSON.stringify(rule_and_condition2),
      });
      setdefaultday2(false);
    } else if (weekday === false && subdata?.values) {
      const urldatavalue =
        subdata?.display_rule_types === "url_path" ||
        subdata?.display_rule_types === "query_string"
          ? JSON.parse(subdata?.values)
          : "";
      setinput(urldatavalue?.sourceUrl);
    }
  }, [weekday, defaultday2]);
  return (
    <>
      <div id={subdata.id} className="selection-menu bg_panel_inputs_wrapp">
        <PanelRow>
          <select
            value={subdata?.display_rule_types}
            onChange={(e) => selectrules(e.target.value, true)}
          >
            {attributes?.dataset2?.map((optgrp) => {
              return (
                <>
                  <optgroup label={optgrp?.label}>
                    <option value="" disabled selected hidden>
                      Please select {RulesTypes2[0]?.label}
                    </option>
                    {RulesTypes2?.map((opt_type) => {
                      if (opt_type.optionType === optgrp?.label) {
                        return (
                          <option
                            value={opt_type?.value}
                            style={{ color: opt_type?.disabled ? "red" : "" }}
                            disabled={opt_type?.disabled}
                          >
                            {opt_type?.label}
                          </option>
                        );
                      }
                    })}
                  </optgroup>
                </>
              );
            })}
          </select>
        </PanelRow>
        <PanelRow>
          <SelectControl
            value={subdata?.operators?.length > 0 ? subdata.operators : ""}
            options={opreatorOption}
            placeholder={__("Select some users:")}
            onChange={(newval) => setOperator(newval)}
          />
        </PanelRow>
        <PanelRow>
          {!inputstatus ? (
            <Select
              value={JSON.stringify(option)?.length > 2 ? option : []}
              options={ProductOption}
              isMulti={condition_input_type}
              onChange={(e) => setproducts(e, "option")}
            />
          ) : (
            <>
              {inputType === "date" ? (
                <>
                  <div class="datepicker_day">
                    {daysOfWeek.map((item) => (
                      <label key={item.id}>
                        <input
                          type="checkbox"
                          value={item}
                          checked={selectedDays?.some(
                            (checkedItem) => checkedItem.id === item.id
                          )}
                          onChange={() => setproducts(item, "date")}
                        />
                        {item.day}
                      </label>
                    ))}
                  </div>
                  <div class="datepicker_range">
                    <DatePicker
                      selected={daterange.start}
                      onChange={handleStartDateChange}
                      placeholderText="Now"
                      // onKeyDown={(e) => e.preventDefault()}
                      showTimeInput
                      dateFormat="dd/MM/yyyy h:mm aa"
                    />
                    <DatePicker
                      selected={daterange.end}
                      onChange={handleEndDateChange}
                      placeholderText="Forever"
                      // onKeyDown={(e) => e.preventDefault()}
                      showTimeInput
                      dateFormat="dd/MM/yyyy h:mm aa"
                    />
                  </div>
                </>
              ) : (
                <>
                  {/* <input
                    value={
                      ProductOption[0]?.label === "Html_Always"
                        ? ProductOption[0]?.value
                        : option[0]?.value
                    }
                    onChange={(e) => setproducts(e, "input")}
                    disabled={
                      ProductOption[0]?.label === "Html_Always" &&
                      ProductOption[0]?.value
                    }t
                  /> */}
                  {ProductOption[0]?.label === "Html_Always" ? (
                    <input
                      value={ProductOption[0].value}
                      disabled={
                        ProductOption[0]?.label === "Html_Always" &&
                        ProductOption[0]?.value
                      }
                    />
                  ) : (
                    <textarea
                      class="textara_urlsources"
                      placeholder='Separate values by "|".'
                      value={option.length > 0 ? option[0]?.value : input}
                      onChange={(e) => {
                        option.length > 0
                          ? setproducts(e, "input")
                          : setdefaultday2(true),
                          setinput(e.target.value);
                      }}
                    />
                  )}
                </>
              )}
            </>
          )}
        </PanelRow>
        <PanelRow>
          <div class="bg_panel_btns_wrapp">
            <button class="db_panel_btn_add" onClick={() => AddedSubProduct()}>
              <span class="dashicons dashicons-plus"></span>
            </button>
            <button
              class="db_panel_btn_remove"
              onClick={() => removeSubProduct(subdata.sub_id)}
            >
              <span class="dashicons dashicons-minus"></span>
            </button>
          </div>
        </PanelRow>
      </div>
    </>
  );
};
const ProductSubCategory = (props) => {
  const {
    rule_and_condition,
    setAttributes,
    attributes,
    setRulesCondition,
    list,
    RulesTypes,
    removeform,
    setRemoveform,
    dragstatus,
    defaultreset,
    setdefaultreset,
    setDragstatus,
    removeCrosssign,
    subdata,
  } = props;

  const [ProductOption, setProductOption] = useState([]);
  const [option, setoption] = useState();
  const [inputstatus, setinputstatus] = useState(Boolean);
  const [opreatorOption, setopreatorOption] = useState([]);
  const [condition_input_type, setCondition_input_type] = useState(true);
  useEffect(() => {
    if (removeform || dragstatus) {
      selectrules(subdata?.display_rule_types, false);
    }
  }, [rule_and_condition]);
  useEffect(() => {
    if (subdata?.display_rule_types?.length > 0) {
      selectrules(subdata?.display_rule_types, false);
    } else {
      let defaultOption = RulesTypes?.filter((option) => {
        return option?.optionType === attributes?.dataset[0].value;
      });
      selectrules(defaultOption[0].value, false);
    }
    removeCrosssign();
  }, [list?.data_filter.length]);
  useEffect(() => {
    if (subdata?.display_rule_types) {
      const optionTypess = RulesTypes?.find((getopt) => {
        return getopt?.value === subdata?.display_rule_types;
      });
      if (optionTypess) {
        ``;
        let resetOption = attributes?.dataset?.filter((option) => {
          return option?.value === optionTypess?.optionType;
        });
        if (resetOption.length === 0) {
          subdata.values = "";
          subdata.operators = "";
          let defaultOption = RulesTypes?.filter((option) => {
            return option?.optionType === attributes?.dataset[0]?.value;
          });
          if (defaultOption) {
            return selectrules(defaultOption[0].value, false);
          }
        }
      }
    }
  }, [attributes?.dataset]);

  const getListCondition = async (display, status) => {
    await resetData(status);
    const pro_version = RulesTypes?.filter((pro) => {
      return pro.value === display;
    });
    if (pro_version.length > 0) {
      getDetails(pro_version[0]?.value, status, "version");
    } else {
      getDetails(RulesTypes[0]?.value, status, "pro_version");
    }
  };
  const getDetails = (display, status, versions) => {
    subdata.display_rule_types = display;
    const postss = RulesTypes?.filter((data) => {
      if (data.value === display) {
        return data;
      }
    });
    apiFetch({
      path: `/dynamicblock/v1/display_rule_types?rule_type=${display}`,
    }).then((posts) => {
      // operators
      if (posts) {
        if (posts.condition_input_type) {
          if (
            posts.condition_input_type === "Product_Select" ||
            posts.condition_input_type === "Chosen_Select"
          ) {
            setinputstatus(false);
            setCondition_input_type(true);
          } else if (
            posts.condition_input_type === "Price_Select" ||
            posts.condition_input_type === "Text" ||
            posts.condition_input_type === "Store_Order_Count"
          ) {
            setinputstatus(true);
          } else if (
            posts.condition_input_type === "Order_Status" ||
            posts.condition_input_type === "Select"
          ) {
            setinputstatus(false);
            setCondition_input_type(false);
          } else {
            setCondition_input_type(true);
          }
        }
        if (opreatorOption.length === 0) {
          let operator = posts?.operators;
          for (const [key, value] of Object?.entries(operator)) {
            let rules = {};
            (rules.label = value),
              (rules.value = key),
              opreatorOption.push(rules);
            setopreatorOption(opreatorOption);
          }
        }
        //  values
        let values = posts.values;
        for (const [key, value] of Object?.entries(values)) {
          let rules = {};
          (rules.label = value), (rules.value = key), ProductOption.push(rules);
          setProductOption(ProductOption);
        }
        return applyconditions(status, versions);
      }
    });
  };

  const AddedSubProduct = () => {
    const newSubRules = {
      sub_id: uuidv4(),
      display_rule_types: "",
      values: "",
      operators: "",
      child_rule_type: 0,
    };
    list?.data_filter?.push(newSubRules);
    setRulesCondition(rule_and_condition);
    setAttributes({
      rule_and_condition: JSON.stringify(rule_and_condition),
    });
  };
  const removeSubProduct = (subdata_id) => {
    const removeval = list?.data_filter?.filter((sub) => {
      if (sub?.sub_id !== subdata_id) {
        return sub;
      }
    });
    if (removeval[0]?.sub_id?.length > 0) {
      while (list?.data_filter?.length) {
        list?.data_filter.pop();
      }
      if (removeval[0]?.sub_id?.length > 0 && list?.data_filter.length === 0) {
        removeval.map((data_remain) => {
          list?.data_filter.push(data_remain);
          setRulesCondition(rule_and_condition);
          return setAttributes({
            rule_and_condition: JSON.stringify(rule_and_condition),
          });
        });
      }
    }
  };
  const applyconditions = (status, versions) => {
    if (defaultreset) {
      setOperator(opreatorOption[0]?.value);
      subdata.values = "";
      setoption([]);
      setdefaultreset(false);
      setRulesCondition(rule_and_condition);
      return setAttributes({
        rule_and_condition: JSON.stringify(rule_and_condition),
      });
    } else if (
      !defaultreset &&
      !dragstatus &&
      removeform &&
      subdata.values.length &&
      subdata.operators.length
    ) {
      // when defaultreset  is false and removeform
      const selectremoveform =
        subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
      setoption(selectremoveform);
      setRemoveform(false);
    } else if (dragstatus) {
      setoption([]);
      // setopreatorOption([])
      setDragstatus(false);
      const val =
        subdata?.values.length === 0 ? "" : JSON.parse(subdata?.values);
      return setoption(val);
    } else if (status) {
      subdata.values = "";
      subdata.operators = opreatorOption[0]?.value;
      setOperator(opreatorOption[0]?.value);
    } else if (versions === "pro_version") {
      subdata.operators = "";
      subdata.values = "";
      setoption([]);
      0;
      setRulesCondition(rule_and_condition);
      return setAttributes({
        rule_and_condition: JSON.stringify(rule_and_condition),
      });
    } else {
      const selectedoption =
        subdata.values?.length > 0 ? JSON.parse(subdata?.values) : [];
      setoption(selectedoption);
    }
  };

  const resetData = async (status) => {
    if (status) {
      setoption([]);
    }
    while (opreatorOption?.length) {
      opreatorOption.pop();
    }
    while (ProductOption?.length) {
      ProductOption.pop();
    }
    setopreatorOption([]);
    setRulesCondition(rule_and_condition);
    setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
  };

  const selectrules = (option, status) => {
    subdata.display_rule_types = option;
    getListCondition(option, status);
    setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
  };

  const setOperator = (option) => {
    subdata.operators = option;
    setRulesCondition(rule_and_condition);
    setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
  };

  const setproducts = (option, type) => {
    subdata.operators =
      subdata.operators.length > 0
        ? subdata.operators
        : opreatorOption[0].value;
    if ("option" === type) {
      if (condition_input_type) {
        0;
        subdata.values = JSON.stringify(option);
      } else {
        subdata.values = JSON.stringify([option]);
      }
      setoption(option);
      setRulesCondition(rule_and_condition);
      setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
    } else if (inputstatus) {
      const { type, value } = option.target;
      let objectval = {
        label: type,
        value: value,
      };
      subdata.values = JSON.stringify([objectval]);
      setoption(objectval);
      setRulesCondition(rule_and_condition);
      setAttributes({ rule_and_condition: JSON.stringify(rule_and_condition) });
    }
  };
  return (
    <>
      <div id={subdata.id} className="selection-menu bg_panel_inputs_wrapp">
        <PanelRow>
          <select
            value={subdata?.display_rule_types}
            onChange={(e) => selectrules(e.target.value, true)}
          >
            {attributes?.dataset?.map((optgrp) => {
              return (
                <>
                  <optgroup label={optgrp?.label}>
                    <option value="" disabled selected hidden>
                      Please select {RulesTypes[0]?.label}
                    </option>
                    {RulesTypes?.map((opt_type) => {
                      if (opt_type.optionType === optgrp?.label) {
                        return (
                          <option
                            value={opt_type?.value}
                            style={{ color: opt_type?.disabled ? "red" : "" }}
                            disabled={opt_type?.disabled}
                          >
                            {opt_type?.label}
                          </option>
                        );
                      }
                    })}
                  </optgroup>
                </>
              );
            })}
          </select>
        </PanelRow>
        <PanelRow>
          <SelectControl
            value={subdata?.operators?.length > 0 ? subdata.operators : ""}
            options={opreatorOption}
            placeholder={__("Select some users:")}
            onChange={(newval) => setOperator(newval)}
          />
        </PanelRow>

        <PanelRow>
          {!inputstatus ? (
            <Select
              value={JSON.stringify(option)?.length > 2 ? option : []}
              options={ProductOption}
              isMulti={condition_input_type}
              onChange={(e) => setproducts(e, "option")}
            />
          ) : (
            <input
              value={option[0]?.value}
              onChange={(e) => setproducts(e, "input")}
            />
          )}
        </PanelRow>
        <PanelRow>
          <div class="bg_panel_btns_wrapp">
            <button class="db_panel_btn_add" onClick={() => AddedSubProduct()}>
              <span class="dashicons dashicons-plus"></span>
            </button>
            <button
              class="db_panel_btn_remove"
              onClick={() => removeSubProduct(subdata.sub_id)}
            >
              <span class="dashicons dashicons-minus"></span>
            </button>
          </div>
        </PanelRow>
      </div>
    </>
  );
};
const StyleComponent = (props) => {
  const { attributes, setAttributes } = props;
  const getAttr = props.props.attributes;
  {
    /* grid carosel slider changes start 28/03/2024 */
  }
  const Columnsetting = [
    {
      grid: {
        desktop_column:
          getAttr?.carouselToggle === true
            ? "auto"
            : getAttr?.desktop_auto_slide === true ? "auto" :getAttr?.desktop_slide,
        tablet_column:
          getAttr?.carouselToggle === true
            ? "auto"
            :getAttr?.tablet_auto_slide === true ? "auto" : getAttr?.tablet_slide,
        mobile_column:
          getAttr?.carouselToggle === true
            ? "auto"
            :getAttr?.mobile_auto_slide === true ? "auto" : getAttr?.mobile_slide,
      },
      carousel: {
        desktop_column:
          getAttr?.carouselToggle === true
            ?  getAttr?.desktop_auto_slide === true ? "auto" :getAttr?.desktop_slide
            : "auto",
        tablet_column:
          getAttr?.carouselToggle === true
            ? getAttr?.tablet_auto_slide === true ? "auto" : getAttr?.tablet_slide
            : "auto",
        mobile_column:
          getAttr?.carouselToggle === true
            ? getAttr?.mobile_auto_slide === true ? "auto" : getAttr?.mobile_slide
            : "auto",
      },
    },
  ];
  const Spacesetting = [
    {
      grid: {
        desktop_space:
          getAttr?.carouselToggle === true ? 5 : getAttr?.desktop_spacing,
        tablet_space:
          getAttr?.carouselToggle === true ? 5 : getAttr?.tablet_spacing,
        mobile_space:
          getAttr?.carouselToggle === true ? 5 : getAttr?.mobile_spacing,
      },
      carousel: {
        desktop_space:
          getAttr?.carouselToggle === true ? getAttr?.desktop_spacing : 5,
        tablet_space:
          getAttr?.carouselToggle === true ? getAttr?.tablet_spacing : 5,
        mobile_space:
          getAttr?.carouselToggle === true ? getAttr?.mobile_spacing : 5,
      },
    },
  ];
  //const randomnumber=uuidv4().substring(0,10)
  //getAttr.id=randomnumber;
  getAttr.columnSetting = Columnsetting;
  getAttr.spaceSetting = Spacesetting;
  setAttributes(getAttr);

  const slideCount = [1, 2, 3, 4, 5, 6];
  const displayView = [
    { device: "Desktop", icons: faDisplay },
    { device: "Tablet", icons: faTabletScreenButton },
    { device: "Mobile", icons: faMobileScreen },
  ];
  const spacingView = [0, 2, 5, 10, 20, 30];
  {
    /* grid carosel slider changes end */
  }
  return (
    <PanelBody
      className="bg_style_tab_content bg_block_tab_content_wrap"
      title="Content Options"
      initialOpen={true}
    >
      <PanelRow>
        <ToggleControl
          className="gb-toggle-control"
          label={__("Show Product Excerpt")}
          help={__("display short description")}
          checked={getAttr.excerptToggle}
          onChange={(val) => setAttributes({ excerptToggle: val })}
        />
      </PanelRow>
      <PanelRow>
        {/* grid carosel slider changes start 28/03/2024 */}
        <>
          <h4
            style={{
              paddingBottom: "5px",
              margin: "10px 0",
              color: "#333",
              fontWeight: "400",
              fontSize: "14px",
              borderBottom: "1px solid #1010101a",
            }}
          >
            {__("Grid or carousel")}
          </h4>
          <div
            className={`${
              getAttr.carouselToggle === false ? "gridclass" : "caroselclass"
            } allBtn`}
          >
            <button
              className={`${
                getAttr.carouselToggle === false && "btnChanges"
              } btnClass`}
              onClick={() => {
                setAttributes({
                  carouselToggle: false,
                  carousel_column: "Desktop",
                  desktop_slide: getAttr.carouselToggle === true && 4,
                  tablet_slide: getAttr.carouselToggle === true && 3,
                  mobile_slide: getAttr.carouselToggle === true && 1,
                  desktop_spacing: getAttr.carouselToggle === true && 5,
                  tablet_spacing: getAttr.carouselToggle === true && 5,
                  mobile_spacing: getAttr.carouselToggle === true && 5,
                  autoplayToggle: false,
                  mobile_auto_slide: true,
                  tablet_auto_slide: true,
                  desktop_auto_slide: true,
                });
              }}
            >
              {__("Grid")}
            </button>
            <button
              className={`${
                getAttr.carouselToggle === true && "btnChanges"
              } btnClass`}
              onClick={() => {
                setAttributes({
                  carouselToggle: true,
                  carousel_column: "Desktop",
                  desktop_slide: getAttr.carouselToggle === false && 4,
                  tablet_slide: getAttr.carouselToggle === false && 3,
                  mobile_slide: getAttr.carouselToggle === false && 1,
                  desktop_spacing: getAttr.carouselToggle === false && 5,
                  tablet_spacing: getAttr.carouselToggle === false && 5,
                  mobile_spacing: getAttr.carouselToggle === false && 5,
                  carousel_spacing: 5,
                  mobile_auto_slide: true,
                  tablet_auto_slide: true,
                  desktop_auto_slide: true,
                });
              }}
              disabled={getAttr.carouselToggle === true}
            >
              {__("Carousel")}
            </button>
          </div>
        </>
        {getAttr.carouselToggle === true ? (
          <div style={{ margin: "8px 0" }}>
            <PanelRow>
              <ToggleControl
                className="gb-toggle-control"
                label={__("AutoPlay")}
                checked={getAttr.autoplayToggle}
                help={__("enable autoplay for carousel")}
                onChange={(val) => setAttributes({ autoplayToggle: val })}
              />
            </PanelRow>
            <div className="responsive_view">
              <h4 style={{ color: "#333" }}>Columns</h4>
              <div className="device_view">
                {displayView?.map((value, index) => {
                  const { device, icons } = value;
                  return (
                    <h4
                      key={index}
                      className={`${
                        getAttr.carousel_column === device ? "text_chnges" : ""
                      }`}
                      onClick={() => {
                        setAttributes({
                          carousel_column: device,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        icon={icons}
                        style={{ paddingRight: "3px" }}
                      />
                    </h4>
                  );
                })}
              </div>
            </div>
            <div className="caurosel_grid">
              {(() => {
                switch (getAttr?.carousel_column) {
                  case "Mobile":
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.mobile_auto_slide === true && "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: getAttr?.tablet_slide,
                              desktop_slide: getAttr?.desktop_slide,
                              mobile_slide: 1,
                              mobile_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          if (index <= 1) {
                            return (
                              <>
                                <h4
                                  key={index}
                                  className={`${
                                    getAttr?.mobile_slide === number &&
                                    getAttr?.mobile_auto_slide === false
                                      ? "grid_chnges"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setAttributes({
                                      mobile_slide: number,
                                      mobile_auto_slide: false,
                                    });
                                  }}
                                >
                                  {number}
                                </h4>
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  case "Tablet":
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.tablet_auto_slide === true && "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: 3,
                              desktop_slide: getAttr?.desktop_slide,
                              mobile_slide: getAttr?.mobile_slide,
                              tablet_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          if (index <= 3) {
                            return (
                              <>
                                <h4
                                  key={index}
                                  className={`${
                                    getAttr?.tablet_slide === number &&
                                    getAttr?.tablet_auto_slide === false
                                      ? "grid_chnges"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setAttributes({
                                      tablet_slide: number,
                                      tablet_auto_slide: false,
                                    });
                                  }}
                                >
                                  {number}
                                </h4>
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  case "Desktop":
                  default:
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.desktop_auto_slide === true &&
                            "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: getAttr?.tablet_slide,
                              desktop_slide: 4,
                              mobile_slide: getAttr?.mobile_slide,
                              desktop_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          return (
                            <>
                              <h4
                                key={index}
                                className={`${
                                  getAttr?.desktop_slide === number &&
                                  getAttr?.desktop_auto_slide === false
                                    ? "grid_chnges"
                                    : ""
                                }`}
                                onClick={() => {
                                  setAttributes({
                                    desktop_slide: number,
                                    desktop_auto_slide: false,
                                  });
                                }}
                              >
                                {number}
                              </h4>
                            </>
                          );
                        })}
                      </>
                    );
                }
              })()}
            </div>
            <h4
              style={{
                borderBottom: "1px solid #1010101a",
                padding: "0 0 5px 0",
                margin: "0",
              }}
            >
              {__("Space between products")}
            </h4>
            <div className="spacing_view caurosel_grid">
              {spacingView?.map((space, index) => {
                switch (getAttr?.carousel_column) {
                  case "Tablet":
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.tablet_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ tablet_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                  case "Mobile":
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.mobile_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ mobile_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                  case "Desktop":
                  default:
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.desktop_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ desktop_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                }
              })}
            </div>
          </div>
        ) : (
          <>
            {" "}
            <div className="responsive_view">
              <h4 style={{ color: "#333" }}>Columns</h4>
              <div className="device_view">
                {displayView?.map((value, index) => {
                  const { device, icons } = value;
                  return (
                    <h4
                      key={index}
                      className={`${
                        getAttr.carousel_column === device ? "text_chnges" : ""
                      }`}
                      onClick={() => {
                        setAttributes({
                          carousel_column: device,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        icon={icons}
                        style={{ paddingRight: "3px" }}
                      />
                    </h4>
                  );
                })}
              </div>
            </div>
            <div className="caurosel_grid">
              {(() => {
                switch (getAttr?.carousel_column) {
                  case "Mobile":
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.mobile_auto_slide === true && "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: getAttr?.tablet_slide,
                              desktop_slide: getAttr?.desktop_slide,
                              mobile_slide: 1,
                              mobile_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          if (index <= 1) {
                            return (
                              <>
                                <h4
                                  key={index}
                                  className={`${
                                    getAttr?.mobile_slide === number &&
                                    getAttr?.mobile_auto_slide === false
                                      ? "grid_chnges"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setAttributes({
                                      mobile_slide: number,
                                      mobile_auto_slide: false,
                                    });
                                  }}
                                >
                                  {number}
                                </h4>
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  case "Tablet":
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.tablet_auto_slide === true && "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: 3,
                              desktop_slide: getAttr?.desktop_slide,
                              mobile_slide: getAttr?.mobile_slide,
                              tablet_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          if (index <= 3) {
                            return (
                              <>
                                <h4
                                  key={index}
                                  className={`${
                                    getAttr?.tablet_slide === number &&
                                    getAttr?.tablet_auto_slide === false
                                      ? "grid_chnges"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setAttributes({
                                      tablet_slide: number,
                                      tablet_auto_slide: false,
                                    });
                                  }}
                                >
                                  {number}
                                </h4>
                              </>
                            );
                          }
                        })}
                      </>
                    );
                  case "Desktop":
                  default:
                    return (
                      <>
                        <h4
                          className={`${
                            getAttr?.desktop_auto_slide === true &&
                            "grid_chnges"
                          }`}
                          onClick={() => {
                            setAttributes({
                              tablet_slide: getAttr?.tablet_slide,
                              desktop_slide: 4,
                              mobile_slide: getAttr?.mobile_slide,
                              desktop_auto_slide: true,
                            });
                          }}
                        >
                          Auto
                        </h4>
                        {slideCount?.map((number, index) => {
                          return (
                            <>
                              <h4
                                key={index}
                                className={`${
                                  getAttr?.desktop_slide === number &&
                                  getAttr?.desktop_auto_slide === false
                                    ? "grid_chnges"
                                    : ""
                                }`}
                                onClick={() => {
                                  setAttributes({
                                    desktop_slide: number,
                                    desktop_auto_slide: false,
                                  });
                                }}
                              >
                                {number}
                              </h4>
                            </>
                          );
                        })}
                      </>
                    );
                }
              })()}
            </div>
            <h4
              style={{
                borderBottom: "1px solid #1010101a",
                padding: "0 0 5px 0",
                margin: "0",
              }}
            >
              {__("Space between products")}
            </h4>
            <div className="spacing_view caurosel_grid">
              {spacingView?.map((space, index) => {
                switch (getAttr?.carousel_column) {
                  case "Tablet":
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.tablet_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ tablet_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                  case "Mobile":
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.mobile_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ mobile_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                  case "Desktop":
                  default:
                    return (
                      <h4
                        key={index}
                        className={`${
                          getAttr?.desktop_spacing === space && "grid_chnges"
                        }`}
                        onClick={() => {
                          setAttributes({ desktop_spacing: space });
                        }}
                      >
                        {__(`${space}`)}
                      </h4>
                    );
                }
              })}
            </div>
          </>
        )}
        {/* grid carosel slider changes end*/}
      </PanelRow>
      <PanelRow>
        <ToggleControl
          className="gb-toggle-control"
          label={__("Display Add to Cart Button")}
          checked={getAttr.addToCartBtnToggle}
          help={__("display add to cart")}
          onChange={(val) => setAttributes({ addToCartBtnToggle: val })}
        />
      </PanelRow>
    </PanelBody>
  );
};

const AdvancedComponent = (props) => {
  const { attributes, setAttributes } = props;
  const getAttr = props.props.attributes;
  return (
    <div>
      <PanelBody
        className="bg_advanced_tab_content bg_block_tab_content_wrap"
        title={__("Style")}
        initialOpen={true}
      >
        <PanelRow>
          <TextControl
            label={__("Custom Css Class")}
            placeholder={__("insert here custom class")}
            value={getAttr.gbcustomCssClass}
            onChange={(val) => setAttributes({ gbcustomCssClass: val })}
          />
        </PanelRow>
        <PanelRow>
          <div className="gb_code_mirror_cmp">
            <label>Custom Css</label>
            <CodeMirror
              placeholder={__("#id {\n   d isplay: block;\n}")}
              value={getAttr.gbcustomCss}
              extensions={[css()]}
              label={__("Custom Css Class")}
              onChange={(val) => setAttributes({ gbcustomCss: val })}
            />
          </div>
        </PanelRow>
        <PanelRow>
          <div className="gb_code_mirror_cmp">
            <label>Custom JS</label>
            <CodeMirror
              placeholder={__("console.log('success...');")}
              value={getAttr.gbcustomJs}
              extensions={[basicSetup, javascript()]}
              onChange={(val) => setAttributes({ gbcustomJs: val })}
            />
          </div>
        </PanelRow>
      </PanelBody>
      <PanelBody title={__("UTM Params")} initialOpen={false}>
        <PanelRow>
          <TextareaControl
            label={__("UTM Source")}
            type="textarea"
            placeholder={__("UTM Source")}
            value={getAttr.gbutmSource}
            onChange={(val) => setAttributes({ gbutmSource: val })}
          />
        </PanelRow>
        <PanelRow>
          <TextareaControl
            label={__("UTM Medium")}
            type="textarea"
            placeholder={__("UTM Medium")}
            value={getAttr.gbutmMedium}
            onChange={(val) => setAttributes({ gbutmMedium: val })}
          />
        </PanelRow>
        <PanelRow>
          <TextareaControl
            label={__("UTM Campaign")}
            type="textarea"
            placeholder={__("UTM Campaign")}
            value={getAttr.gbutmCampaign}
            onChange={(val) => setAttributes({ gbutmCampaign: val })}
          />
        </PanelRow>
      </PanelBody>
    </div>
  );
};

